export const CompatibleProductsEntitlementSlugKeys = Object.freeze({
  JIRA_CORE: 'product.jira-core.ccpEntitlementSlug',
  JIRA_SERVICE_DESK: 'product.jira-servicedesk.ccpEntitlementSlug',
  JIRA_SOFTWARE: 'product.jira-software.ccpEntitlementSlug',
  CONFLUENCE: 'product.confluence.ccpEntitlementSlug',
  COMPASS: 'product.compass.ccpEntitlementSlug'
});